import getLeader from "./getLeader"

const leader = { getLeader }
export { getLeader }

export default leader
